module.exports = __webpack_public_path__ + "img/8-1_02.026bb16d.jpg";